import { useState, useEffect } from "react";
import { Wifi, WifiOff, Database, Clock, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export default function ApiStatusBar() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.getApiStatus().then(setStatus).catch(() => {});
    const interval = setInterval(() => {
      api.getApiStatus().then(setStatus).catch(() => {});
    }, 300000); // Check every 5 min
    return () => clearInterval(interval);
  }, []);

  if (!status) return null;

  const isActive = status.status === "active";
  const isSuspended = status.status === "suspended";
  const remaining = status.requests?.remaining ?? 0;
  const limit = status.requests?.limit_day ?? 100;
  const pct = limit > 0 ? Math.round((remaining / limit) * 100) : 0;

  return (
    <div
      className={`flex items-center gap-3 px-3 py-1.5 rounded-sm text-[10px] font-mono border ${
        isActive
          ? remaining < 10 ? "border-warning/30 bg-warning/5" : "border-line bg-surface"
          : "border-danger/30 bg-danger/5"
      }`}
      data-testid="api-status-bar"
    >
      {isActive ? (
        <Wifi className="w-3 h-3 text-volt" />
      ) : isSuspended ? (
        <WifiOff className="w-3 h-3 text-danger" />
      ) : (
        <AlertTriangle className="w-3 h-3 text-warning" />
      )}

      <span className={isActive ? "text-txt-secondary" : "text-danger"}>
        API: {isActive ? "Ativa" : isSuspended ? "Suspensa" : "Desconhecida"}
      </span>

      {isActive && (
        <>
          <span className="text-txt-secondary">|</span>
          <span className={remaining < 10 ? "text-warning" : "text-txt-secondary"}>
            {remaining}/{limit} pedidos
          </span>
          {/* Mini progress bar */}
          <div className="w-16 h-1 bg-obsidian rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full ${
                pct > 50 ? "bg-volt" : pct > 20 ? "bg-warning" : "bg-danger"
              }`}
              style={{ width: `${pct}%` }}
            />
          </div>
        </>
      )}

      {isSuspended && (
        <>
          <span className="text-warning">|</span>
          <a
            href={status.action_url || "https://dashboard.api-football.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="text-warning underline hover:text-white transition-colors"
          >
            Conta suspensa - Clica para reativar
          </a>
        </>
      )}
    </div>
  );
}
